export default "__VITE_ASSET__B$FgP$9z__"